  import React, { useState, useEffect, useRef } from 'react';
  import { toast } from 'react-toastify';
  import ReactCodeInput from 'react-verification-code-input';
  import { useMessageBox } from '../../../context/MessageBox';
  import api from '../../../services/api';
  import { handleErrorRequest } from '../../../utils/errorsValidation';
  import * as S from './styles';
  
  const ApproveEmail = ({ data, setResponseMessage }) => {
    const { setMessageData } = useMessageBox();
    const [isLoading, setIsLoading] = useState(false);

  
    const submitForm = async () => {
        const formData = {
            ancoraId: data.ancoraId,
            conclusao: data.conclusao,
            dataAtualizacao: data.dataAtualizacao,
            emailInteresseAutenticacaoId: data.emailInteresseAutenticacaoId,
            emailInteresseId: data.emailInteresseId,
            emailInteresseMotivoRecusaId: 0,
            fornecedorId: data.fornecedorId,
            respostaDoFornecedor: ""
        }
        setIsLoading(true);
        try {
          const response = await api.put('OperacoesEmailsInteresses/ConcluirEmailInteresse', formData);
          setMessageData(response.data?.complemento?.mensagensBox);
          if (response.data.resposta.sucesso) {
            toast.success('Interesse Enviado!');
            setResponseMessage(response.data.resposta.mensagem);
          }
        } catch (error) {
          handleErrorRequest(error.response);
        }
        setIsLoading(false);
    };
  
    useEffect(() => {

      
    }, []);
  
    return (
        <div>
            <S.InfoContainer>
              <S.TableTitleHeader>
                <h1>Interesse na Solicitação da Proposta</h1>
              </S.TableTitleHeader>
              <div style={{ padding: '0px 10px' }}>
                <S.ApproveContainer>
                    <div
                        className="message-html"
                        dangerouslySetInnerHTML={{
                          __html: data.mensagem,
                        }}
                      />
                    <S.ConfirmationBox>
                        {data.botaoEnviar && (
                            <S.ActionButton
                                variant="contained"
                                disabled={isLoading}
                                onClick={() => submitForm()}
                            >
                                {isLoading ? 'Solicitando...' : 'Solicitar Proposta'}
                            </S.ActionButton>
                        )}
                    </S.ConfirmationBox>
                </S.ApproveContainer>
              </div>
            </S.InfoContainer>
        </div>
      )
  };
  
  export default ApproveEmail;
  